import { useEffect, useRef } from 'react';
import { useBackgroundController } from './BackgroundController';
import { BrowserRouter } from "react-router-dom";
import { Navbar } from './components/navbar/Navbar';
import { Home } from './pages/home/Home';
import { About } from './pages/about/About';
import { Services } from './pages/services/Services';
import { Statistics } from './pages/statistics/Statistics';
import { Projects } from './pages/projects/Projects';
import { Overview } from './pages/overview/Overview';
import { Contact } from './pages/contact/Contact';
import { ScrollToTop } from './components/scrollToTop/ScrollToTop';
import './App.scss'

function App() {
  // Initialize the global background controller
  useBackgroundController();

  const toastRef = useRef()

  useEffect(() => {
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const updateFavicon = (e) => {
      const favicon = document.getElementById('favicon');
      if (favicon) {
        favicon.href = e.matches ? '/favicon-dark.ico' : '/favicon-light.ico';
      }
    };

    updateFavicon(darkModeMediaQuery); // التحقق عند أول تحميل
    darkModeMediaQuery.addEventListener('change', updateFavicon); // الاستماع للتغيير

    return () => {
      darkModeMediaQuery.removeEventListener('change', updateFavicon); // تنظيف بعد الخروج
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <ScrollToTop />

        <div className="sections-wrapper">
          <Home />
          <About />
          <Services />
          <Statistics />
          <Projects />
          <Overview />
          <Contact toastRef={toastRef} />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;